"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/Features/Features.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Features = forwardRef(function Features2({
  cards,
  titleColor = "text-stone-500",
  className,
  backgroundColor = "bg-display-100"
}, ref) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: `${className} flex justify-center items-center w-full p-24 py-40 h-auto ${backgroundColor}`,
      children: /* @__PURE__ */ jsx("div", { className: "grid md:grid-cols-2 lg:grid-cols-4 gap-24 w-full max-w-[455px] md:max-w-screen-xl", children: cards.map(({ title, icon, description }) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: "flex gap-24 w-full md:max-w-[348px] lg:max-w-[290px]",
          children: [
            /* @__PURE__ */ jsx(
              Icon_default,
              {
                name: icon,
                className: "w-56 md:w-64 min-w-[56px] md:min-w-[64px] h-56 md:h-64 min-h-[56px] md:min-h-[64px]"
              }
            ),
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx(
                "p",
                {
                  className: `md:mb-4 text-[18px] lg:text-[20px] font-bold font-sans ${titleColor}`,
                  children: title
                }
              ),
              /* @__PURE__ */ jsx("p", { className: "text-base font-sans text-display-900", children: description })
            ] })
          ]
        },
        `feature-${title}`
      )) })
    }
  );
});
var Features_default = Features;

export {
  Features_default
};
